import { render, staticRenderFns } from "./addquestion.vue?vue&type=template&id=2d236c38&scoped=true"
import script from "./addquestion.vue?vue&type=script&lang=js"
export * from "./addquestion.vue?vue&type=script&lang=js"
import style0 from "./addquestion.vue?vue&type=style&index=0&id=2d236c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d236c38",
  null
  
)

export default component.exports